import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"
import LauncherPage from "./components/LauncherPage"
import { IOldUIContext } from "../../global"

function init(store: AppStore, oldUIContext: IOldUIContext): void {
    const element = document.getElementById("newui-launcher")

    if (!element) {
        return // we're not on the launcher page, no need to init the login sub app
    }

    const root = createRoot(element)
    root.render(
        <Provider store={store}>
            <OldUIContext.Provider value={oldUIContext}>
                <LauncherPage />
            </OldUIContext.Provider>
        </Provider>,
    )
}

export default init
